import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { addMapMode, removeMapMode } from 'client/store/mapSlice/mapSlice';

import { MapContext } from 'os-elements';
import Button from 'client/components/GDS/Button/Button';
import Icon from '@mdi/react';
import { mdiPencil } from '@mdi/js';

import { mapModes } from 'client/utils/constants/appStates';
import { VALID_MODES } from './EditButton.mode';
import { permissions } from 'client/utils/constants/permissions';
import { useHasUserPermission } from 'client/utils/auth/userPermissions';
import mapModeIsValid from '../validateModes';

const { DEFAULT, DRAWING, MODIFYING, LOADING } = mapModes;

const EditButton = () => {
    const intl = useIntl();
    const hasPermission = useHasUserPermission(permissions.AOI_DRAW);
    const { map } = useContext(MapContext);
    const dispatch = useDispatch();
    const mapMode = useSelector(state => state.map?.mode || []);

    const handleEdit = () => {
        const drawSource = map?.getLayerById('draw')?.getSource();
        const aoiSource = map?.getLayerById('aoi')?.getSource();
        drawSource.clear();
        const features = aoiSource?.getFeatures();
        if (features && features.length > 0) {
            const feature = features[0].clone();
            drawSource?.addFeature(feature);
        }
        dispatch(removeMapMode(DEFAULT));
        dispatch(removeMapMode(DRAWING));
        dispatch(addMapMode(MODIFYING));
    };

    return (hasPermission && mapModeIsValid(mapMode, VALID_MODES))
        ? <Button
            data-testid="mapToolBar.edit"
            variant="success"
            onClick={handleEdit}
            disabled={mapMode.includes(LOADING)}
        >
            <Icon path={mdiPencil} size={0.7}/>
            { intl.formatMessage({ id: 'mapToolbar.editButton.text' }) }
        </Button>
        : null;
};

export default EditButton;
